import {useState, useCallback} from "react";

import { Checkbox, Paper, Table, TableBody, TableCell, 
      TableContainer, TableHead, TableRow } from "@mui/material";

import VariableName from "./VariableName";

export default function VariablesGrid(props) {
  const {variables,variablesFiltered,checkedVariables,researchedVariables,onChangeSelection,
          onChangeColor,onSelectDeselectAll, showAvg=false, avgs, title,} = props

  const [tableBodyWidth, setTableBodyWidth] = useState(0);

  // Funzione per determinare se tutti i checkbox sono selezionati
  const areAllSelected = useCallback(() => {
    const variablesList = variablesFiltered ? variablesFiltered : variables;
    return Object.keys(variablesList).every((key) => 
      checkedVariables.includes(variablesList[key].id));
  },[variablesFiltered, variables, checkedVariables]);

  // Gestione del checkbox "seleziona tutto"
  const handleSelectAll = useCallback(() => {
    const selectAll = !areAllSelected();
    onSelectDeselectAll(selectAll);
  }, [areAllSelected, onSelectDeselectAll]);

  // Ordina le variabili in base alla selezione e alla ricerca
  const orderVariables = useCallback(() => {
    const variablesList = variablesFiltered || variables;

    return Object.keys(variablesList)
      .map((key) => variablesList[key])
      .sort((a, b) => {
        const isCheckedA = checkedVariables.includes(a.id);
        const isSearchedA = researchedVariables.includes(a.id);
        const isCheckedB = checkedVariables.includes(b.id);
        const isSearchedB = researchedVariables.includes(b.id);

        return (
          (isSearchedB - isSearchedA) || // quelle cercate
          (isCheckedB - isCheckedA)     // quelle selezionate
        );
      });
  }, [variablesFiltered, variables, checkedVariables, researchedVariables]);

  const renderAVG = (variable, isChecked) => {
    const avg = avgs[variable.id] != null && avgs[variable.id].toFixed(2)
    // const avgsValue = avg.length > 0 ? avg : (avg !== null && !isChecked ? "no select." : "non Disp.")
    const avgsValue1 = isChecked && avg.length > 0 ? avg : (!isChecked && avg !== null ? "disabilitato" : "Aggiorna")
    return (
      <TableCell align="right">
        {/* {avgsValue} */}
        {avgsValue1}
      </TableCell>
    )
  }

  const renderTableRow = (variable) => {
    const isChecked = checkedVariables.includes(variable.id);
    const isSearched = researchedVariables.includes(variable.id);

    
    return (
      <TableRow key={variable.id} sx={isSearched ?{ background:"white" } : { background:"lightgrey" } }>
        <TableCell>
          <Checkbox
            className="variables-select"
            checked={isChecked}
            color="primary"
            onChange={() => {onChangeSelection(variable.id, !isChecked);}}/>
        </TableCell>
        <TableCell className="variables-color">
          <VariableName
            id={variable.id}
            name={variable.name}
            color={variable.color}
            onColorChange={(color) => {onChangeColor(variable.id, color);}}/>
        </TableCell>
        {/* {showAvg && ( renderAVG(variable))} */}
        {showAvg && renderAVG(variable, isChecked)}
      </TableRow>
    )
  }



  // {Object.keys(variables).map((key) => {
  return (
    <TableContainer component={Paper} sx={{maxHeight:"auto"}}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Checkbox
                    checked={areAllSelected()}
                    onChange={handleSelectAll}
                    color="primary"/>
            </TableCell>
            <TableCell>{title}</TableCell>
            {showAvg && <TableCell align="right">AVG</TableCell>}
          </TableRow>
        </TableHead>
        </Table>
      <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
        <Table size="small" style={{ width: tableBodyWidth ? `${tableBodyWidth}px` : '100%' }}>
          <TableBody>
            {orderVariables().map(variable => renderTableRow(variable))}
          </TableBody>
        </Table>
      </TableContainer>
    </TableContainer>
  )
}
